import store from '@/store'
import moment from 'moment'

export default {

  onRedirect (to) {
    let profile = store.getters['profile/me']
    switch (profile.role) {
      case 'superadmin':
      case 'territorial_agco':
        return {name: 'goals-dealer', replace: true}
      case 'gerente_dealer':
        return {name: 'goals-branch', replace: true}
      case 'gerente_branch':
        return {name: 'goals-seller', params: {branchId: profile.branchId}, replace: true}
      case 'vendedor_dealer':
        return {name: 'seller-my-goals', replace: true}
    }
  },
  onTargetRedirect (to) {
    let profile = store.getters['profile/me']
    switch (profile.role) {
      case 'superadmin':
        return {name: 'goals-target-zone', replace: true}
      case 'territorial_agco':
        return {name: 'goals-target-branch', replace: true}
      default:
        return {name: 'dashboard'}
    }
  },

  onQueryAssignedGoals (type, key) {
    return (to, from, next) => {
      let profile = store.getters['profile/me']
      if (profile.role !== 'territorial_agco') {
        let _query = {...to.query}
        if (type === 'seller') {
          let branches = store.getters['branches/items']
          _query[key] = to.params.id || branches[0].id
        } else if (type === 'branch') {
          // let branches = store.getters['dealers/items']
          // _query[key] = branches.length ? branches[0].id : null
        }
        _query['year'] = moment().format('YYYY')
        if (to.query.year) {
          _query['year'] = to.query.year
        }
        store.dispatch(`assignedGoals/get`, { ..._query, limit: 1000, type })
          .then(({data}) => {
            next()
          })
          .catch(next)
      } else {
        next()
      }
    }
  },

  onQueryGoalItems (resource) {
    return (to, from, next) => {
      let _query = {}
      if (to.query.search) {
        switch (resource) {
          case 'dealers':
            _query['filters[where][name][contains]'] = to.query.search
            break
          case 'branches':
            _query['filters[where][city][contains]'] = to.query.search
            // _query['with'] = 'dealer'
            break
          case 'sellers':
            _query['filters[where][firstName][contains]'] = to.query.search
            _query['filters[where][lastName][contains]'] = to.query.search
            break
        }
      }
      switch (resource) {
        case 'dealers':
          _query.sort = 'name ASC'
          break
        case 'branches':
          break
        case 'sellers':
          _query.sort = 'firstName ASC'
          break
      }
      store.dispatch(`${resource}/query`, {..._query, ...to.query, limit: 1000})
        .then(({data}) => {
          next()
        })
        .catch(next)
    }
  },

  onQueryZoneGoalItems () {
    return (to, from, next) => {
      let _query = {
        'filters[where][role][eq]': 'territorial_agco'
      }
      if (to.query.search) {
        _query['filters[where][firstName][contains]'] = to.query.search
        _query['filters[where][lastName][contains]'] = to.query.search
      }
      store.dispatch(`zones/query`, {..._query, ...to.query, limit: 1000})
        .then(({data}) => {
          next()
        })
        .catch(next)
    }
  },

  onQuery (resource) {
    return (to, from, next) => {
      let _query = {...to.query}
      let _id = to.params.id ? to.params.id : store.getters['zones/items'].length > 0 ? store.getters['zones/items'][0].id : null
      _query['filters[where][year][eq]'] = moment().format('YYYY')
      _query['filters[where][periodicity][eq]'] = 'MONTHLY'
      _query['territorialId'] = _id
      if (to.query.year) {
        _query['filters[where][year][eq]'] = to.query.year
      }

      store.dispatch(`${resource}/query`, {..._query, limit: 5000})
        .then(({data}) => {
          next()
        })
        .catch(next)
    }
  },

  onQueryBranchId (resource) {
    return (to, from, next) => {
      if (to.params.branchId) {
        let _query = {...to.query}
        _query['filters[where][year][eq]'] = moment().format('YYYY')
        _query['filters[where][periodicity][eq]'] = 'MONTHLY'
        if (to.query.year) {
          _query['filters[where][year][eq]'] = to.query.year
        }

        store.dispatch(`${resource}/query`, {..._query, limit: 5000})
          .then(({data}) => {
            next()
          })
          .catch(next)
      } else {
        next()
      }
    }
  },
  onQueryMetGoalsBranchId (resource) {
    return (to, from, next) => {
      if (to.params.branchId) {
        let _query = {...to.query}
        if (!to.query.year) {
          _query.year = moment().format('YYYY')
        }
        _query.id = to.params.branchId

        store.dispatch(`${resource}/metGoals`, {..._query})
          .then(({data}) => {
            next()
          })
          .catch(next)
      } else {
        next()
      }
    }
  },

  onQueryMetGoals (resource, getter) {
    return (to, from, next) => {
      let _query = {...to.query}
      if (!to.query.year) {
        _query.year = moment().format('YYYY')
      }
      if (to.params.id) {
        _query.id = to.params.id
      } else {
        _query.id = store.getters[getter].length ? store.getters[getter][0].id : null
      }
      if (!_query.id) {
        next()
      } else {
        store.dispatch(`${resource}/metGoals`, {..._query})
          .then(({data}) => {
            next()
          })
          .catch(next)
      }
    }
  },

  onQuerySellerGoals (to, from, next) {
    let seller = store.getters['sellers/items'][0]
    let _query = {...to.query}

    _query['filters[where][year][eq]'] = moment().format('YYYY')
    _query['filters[where][periodicity][eq]'] = 'MONTHLY'
    if (to.query.year) {
      _query['filters[where][year][eq]'] = to.query.year
    }
    store.dispatch('sellerGoals/query', {..._query, 'filters[where][userId][eq]': seller.id, limit: 1000})
      .then(({data}) => {
        next()
      })
      .catch(next)
  },

  onQueryGlobalGoals (resource) {
    return (to, from, next) => {
      let _query = {...to.query}
      if (!to.query.year) {
        _query['filters[where][year][eq]'] = moment().format('YYYY')
      } else {
        _query['filters[where][year][eq]'] = to.query.year
      }
      store.dispatch(`${resource}/globalGoals`, {..._query, limit: 5000})
        .then(({data}) => {
          next()
        })
        .catch(next)
    }
  },

  onQueryGlobalMetGoals (resource) {
    return (to, from, next) => {
      let _query = {...to.query}
      if (!to.query.year) {
        _query.year = moment().format('YYYY')
      }
      store.dispatch(`${resource}/globalMetGoals`, {..._query})
        .then(({data}) => {
          next()
        })
        .catch(next)
    }
  }

}



// WEBPACK FOOTER //
// ./src/guards/goals.guards.js